module.exports = __webpack_public_path__ + "img/ondivan_marca_white.14158f74.svg";